import { render } from "./TestAdmin.vue?vue&type=template&id=ed588c34"
import script from "./TestAdmin.vue?vue&type=script&lang=js"
export * from "./TestAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__